ACC.cmscomponents = {
  philipsCustomBanner: '.ph-philipsCustomBanner',
  imagelinkCarousel: function() {
    $('.ph-jcarousel.ph-imageCompCarousel')
      .on('jcarousel:createend', function() {
        $(this).parent().find('.ph-imagelink_loader').remove();
      })
      .on('jcarousel:reload jcarousel:create', function() {
        var $carousel = $(this),
            width = $carousel.innerWidth();


        if (width >= 960.98) {
          width = width / 4;
        } else if (width >= 450.98) {
          width = width / 3;
        } else if (width <= 450.98) {
          width = width / 2;
        }

        $carousel.jcarousel('items').css('width', parseFloat(width) + 'px');
      }).jcarousel({
        wrap: null
      }).jcarouselSwipe({
        perSwipe: 1
      });


    $('.jcarousel-prev.ph-imageCompCarousel')
      .on('jcarouselcontrol:inactive', function() {
        $(this).addClass('inactive');
      })
      .on('jcarouselcontrol:active', function() {
        $(this).removeClass('inactive');
      })
      .jcarouselControl({
        target: '-=1'
      });

    $('.jcarousel-next.ph-imageCompCarousel')
      .on('jcarouselcontrol:inactive', function() {
        $(this).addClass('inactive');
      })
      .on('jcarouselcontrol:active', function() {
        $(this).removeClass('inactive');
      })
      .jcarouselControl({
        target: '+=1'
      });
  },
  customBanner: function() {
    if ($(ACC.cmscomponents.philipsCustomBanner).length > 0) {
      $(ACC.cmscomponents.philipsCustomBanner).addClass('ph-novisibility');
      $(ACC.cmscomponents.philipsCustomBanner).css('height', 'auto');
      $('.ph-philipsCustomBanner__wrapper').find('img').css('height', 'auto');

      var $imageElement = $('.ph-philipsCustomBanner__wrapper').find('img'),
          contentHeight = $('.ph-philipsCustomBanner__foreground').height(),
          dynamicImageHeight = 50;

      if ($imageElement.height() > 50) {
        dynamicImageHeight = $imageElement.height();
      }

      if (contentHeight > 50 && contentHeight > dynamicImageHeight) {
        dynamicImageHeight = parseFloat(contentHeight) + 20;
      }

      $(ACC.cmscomponents.philipsCustomBanner).css('height', dynamicImageHeight + 'px');
      $imageElement.css('height', dynamicImageHeight + 'px');

      if ($('.ph-cmsbannerlinkable').length > 0) {
        $('.ph-philipsCustomBanner__content').on('click', function() {
          $('.ph-cmsbannerlinkable')[0].click();
        });
      }

      $('.ph-philipsCustomBannerLoader').hide();
      $(ACC.cmscomponents.philipsCustomBanner).removeClass('ph-novisibility');
    }
  },
  youtubecompClickFunc: function() {
    $('.ph-youtubecomp_item').on('click', function(e) {
      var loadYoutubePopup = false,
          sourceUrl = '';

      if (e.target.getAttribute('openinpopup') === 'true') {
        loadYoutubePopup = true;
        sourceUrl = e.target.href;
      } else if ($(e.target).parent().attr('openinpopup') === 'true') {
        loadYoutubePopup = true;
        sourceUrl = $(e.target).parent().attr('href');
      }

      if (loadYoutubePopup) {
        e.preventDefault();
        ACC.cmscomponents.loadYoutubeVideoInPopup(sourceUrl);
      }
    });
  },
  youtubeCarousel: function() {
    $('.ph-jcarousel.ph-youtubeCarousel')
      .on('jcarousel:createend', function() {
        $(this).parent().find('.ph-imagelink_loader').remove();
      })
      .on('jcarousel:reload jcarousel:create', function() {
        var $carousel = $(this),
            width = $carousel.innerWidth();

        if (width >= 960.98) {
          width = (width / 3) + 1;
        } else if (width >= 450.98) {
          width = width / 2;
        } else if (width <= 450.98) {
          width = width / 1;
        }

        $carousel.jcarousel('items').css('width', parseFloat(width) + 'px');
      }).jcarousel({
        wrap: null
      }).jcarouselSwipe({
        perSwipe: 1
      });
    $('.jcarousel-prev.ph-youtubeCarousel')
      .on('jcarouselcontrol:inactive', function() {
        $(this).addClass('inactive');
      })
      .on('jcarouselcontrol:active', function() {
        $(this).removeClass('inactive');
      })
      .jcarouselControl({
        target: '-=1'
      });
    $('.jcarousel-next.ph-youtubeCarousel')
      .on('jcarouselcontrol:inactive', function() {
        $(this).addClass('inactive');
      })
      .on('jcarouselcontrol:active', function() {
        $(this).removeClass('inactive');
      })
      .jcarouselControl({
        target: '+=1'
      });
  },
  loadYoutubeVideoInPopup: function(sourceUrl) {
    $('body').append('<div id="youtubeVidWrap"><div id="youtubeVid" style="margin:10px;"></div></div>');
    $.colorbox({
      inline: true,
      href: '#youtubeVidWrap',
      scrolling: true,
      height: '100%',
      width: '100%',
      overlayClose: false,
      close: '<button type=\'button\' class=\'ph-cbox-close\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        var curWidth = $('#cboxWrapper').width() - 30;
        var curHeight = $('#cboxWrapper').height() - 30;

        $('#youtubeVid').html('<iframe width="' + curWidth + '" height="' + curHeight + '" src="' + sourceUrl + '">');
      },
      onClosed: function() {
        $('#youtubeVid iframe').remove();
        $('#youtubeVidWrap').remove();
      }
    });
  }
};
$(document).ready(function() {
  ACC.cmscomponents.imagelinkCarousel();
  ACC.cmscomponents.customBanner();
  ACC.cmscomponents.youtubecompClickFunc();
  ACC.cmscomponents.youtubeCarousel();

  if ($(ACC.cmscomponents.philipsCustomBanner).length > 0) {
    $(window).resize(function() {
      ACC.cmscomponents.customBanner();
    });
  }
});
